import { render, staticRenderFns } from "./VocabularyManager.vue?vue&type=template&id=6a5e39e8&scoped=true&"
import script from "./VocabularyManager.vue?vue&type=script&lang=js&"
export * from "./VocabularyManager.vue?vue&type=script&lang=js&"
import style0 from "./VocabularyManager.vue?vue&type=style&index=0&id=6a5e39e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5e39e8",
  null
  
)

component.options.__file = "VocabularyManager.vue"
export default component.exports